import React from 'react'

const Footer = () => {
  return (
    <div className="container footer">
      <ul className="footer-list">
        <li><h3 className="heading">destinations</h3></li>
        <li><h3 className="heading">contacts</h3></li>
        <li><h3 className="heading">stories</h3></li>
      </ul>
    </div>
  )
}

export default Footer